import { defineComponent } from "vue";
import useDeviceManager from "../../../hooks/useDeviceManager.mjs";
import SvgIcon from "../../common/base/SvgIcon.vue.mjs";
import { storeToRefs } from "pinia";
import CameraSwitchIcon from "../../common/icons/CameraSwitchIcon.vue.mjs";
import { useBasicStore } from "../../../stores/basic.mjs";
import "../../../directives/vTap.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "SwitchCamera",
  setup(__props) {
    const basicStore = useBasicStore();
    const { isFrontCamera } = storeToRefs(basicStore);
    const { deviceManager } = useDeviceManager();
    async function handleSwitchCamera() {
      var _a;
      await ((_a = deviceManager.instance) == null ? void 0 : _a.switchCamera({
        isFrontCamera: !isFrontCamera.value
      }));
      basicStore.setIsFrontCamera(!isFrontCamera.value);
    }
    return { __sfc: true, basicStore, isFrontCamera, deviceManager, handleSwitchCamera, SvgIcon, CameraSwitchIcon };
  }
});
export {
  _sfc_main as default
};
